import { Card, Descriptions, ConfigProvider, Tag } from "antd";

import LockCloseIcon from "@/icons/LockClosedIcon";

import DownloadLink from "@/components/ui/DowloadLink";
import EmployeeProfile from "@/components/cards/EmployeeProfile";
import ContextMenu from "@/components/containers/ContextMenu";

import { formateISODateToStr, getIconByType } from "@/utils";

const FileCard = ({ file, onEdit, onDelete, readOnly }) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Card: {
            bodyPadding: 16,
          },
        },
      }}
    >
      <Card>
        <ConfigProvider
          theme={{
            components: {
              Descriptions: {
                itemPaddingBottom: 10,
              },
            },
          }}
        >
          <Descriptions
            column={1}
            colon={false}
            styles={{
              label: {
                width: 130,
              },
            }}
            extra={
              readOnly ? (
                <LockCloseIcon style={{ color: "#BBBBBB", fontSize: 18 }} />
              ) : (
                <ContextMenu
                  vertical
                  onEdit={() => onEdit(file)}
                  onDelete={() => onDelete(file)}
                />
              )
            }
          >
            <Descriptions.Item label="Имя:">
              <DownloadLink
                href={`/api/file/download?uuid=${file.uuid}`}
                original_name={file.original_name}
                show_icon
              >
                {getIconByType(file.type, file.extension, file.element_type)}
                <div>
                  {file.name}.{file.extension}
                </div>
              </DownloadLink>
            </Descriptions.Item>

            <Descriptions.Item label="Тип:">
              <Tag>{file.type}</Tag>
            </Descriptions.Item>

            <Descriptions.Item label="Дата добавления:">
              {formateISODateToStr(file.created_at)}
            </Descriptions.Item>

            <Descriptions.Item label="Автор:">
              <EmployeeProfile noAvatar {...file.author} />
            </Descriptions.Item>

            <Descriptions.Item label="Описание:">
              {file.description}
            </Descriptions.Item>
          </Descriptions>
        </ConfigProvider>
      </Card>
    </ConfigProvider>
  );
};

export default FileCard;
